/**
 * Generated by orval v8.1.0 🍺
 * Do not edit manually.
 * RepeatMD.PatientApp, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CapturePatientMarketingConsentRequest,
  CartModel,
  ChangePhoneNumberForPlatformUserRequest,
  DisplayChangePhoneNumberForPlatformUserResponse,
  ExternalTransactionDetails,
  GetOrderHistoryParams,
  GetUserRewardHistoryParams,
  GetUserRewardHistoryResultPagedResults,
  GetVisitHistoryResultPagedResults,
  OrderHistoryLineItemModelPagedResults,
  SavePreferencesRequest,
  UpdateUserRequest,
  UploadImageBody,
  UploadImageCommandResult,
  UserGetVisitHistoryCheckInsParams,
  UserGetVisitHistoryVisitsParams,
  UserModel1,
  UserPreferences
} from '.././model';

import { customAxios } from '../../custom-axios';
import type { ErrorType } from '../../custom-axios';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Uploads an image to AWS or local storage and returns a url.
 */
export const uploadImage = (
    uploadImageBody: UploadImageBody,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      const formData = new FormData();
if(uploadImageBody.file !== undefined) {
 formData.append(`file`, uploadImageBody.file);
 }

      return customAxios<UploadImageCommandResult>(
      {url: `/api/v1/uploads`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }
  


export const getUploadImageMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadImage>>, TError,{data: UploadImageBody}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadImage>>, TError,{data: UploadImageBody}, TContext> => {

const mutationKey = ['uploadImage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadImage>>, {data: UploadImageBody}> = (props) => {
          const {data} = props ?? {};

          return  uploadImage(data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type UploadImageMutationResult = NonNullable<Awaited<ReturnType<typeof uploadImage>>>
    export type UploadImageMutationBody = UploadImageBody
    export type UploadImageMutationError = ErrorType<unknown>

    /**
 * @summary Uploads an image to AWS or local storage and returns a url.
 */
export const useUploadImage = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadImage>>, TError,{data: UploadImageBody}, TContext>, request?: SecondParameter<typeof customAxios>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof uploadImage>>,
        TError,
        {data: UploadImageBody},
        TContext
      > => {
      return useMutation(getUploadImageMutationOptions(options));
    }
    /**
 * @summary Gets the current user details.
 */
export const getUserInfo = (
    
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<UserModel1>(
      {url: `/api/v1/user`, method: 'GET', signal
    },
      options);
    }
  



export const getGetUserInfoQueryKey = () => {
    return [
    `/api/v1/user`
    ] as const;
    }

    
export const getGetUserInfoQueryOptions = <TData = Awaited<ReturnType<typeof getUserInfo>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserInfo>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserInfoQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserInfo>>> = ({ signal }) => getUserInfo(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserInfo>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getUserInfo>>>
export type GetUserInfoQueryError = ErrorType<void>


/**
 * @summary Gets the current user details.
 */

export function useGetUserInfo<TData = Awaited<ReturnType<typeof getUserInfo>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserInfo>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUserInfoQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Delete the current user's account. This will cancel active memberships
and either nullify PII or create an empty user depending on platform associations.
 */
export const deleteAccount = (
    
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/user`, method: 'DELETE', signal
    },
      options);
    }
  


export const getDeleteAccountMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAccount>>, TError,void, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAccount>>, TError,void, TContext> => {

const mutationKey = ['deleteAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAccount>>, void> = () => {
          

          return  deleteAccount(requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAccountMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAccount>>>
    
    export type DeleteAccountMutationError = ErrorType<void>

    /**
 * @summary Delete the current user's account. This will cancel active memberships
and either nullify PII or create an empty user depending on platform associations.
 */
export const useDeleteAccount = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAccount>>, TError,void, TContext>, request?: SecondParameter<typeof customAxios>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteAccount>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDeleteAccountMutationOptions(options));
    }
    /**
 * @summary Update the verified User's information
 */
export const updateUser = (
    updateUserRequest: UpdateUserRequest,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<UserModel1>(
      {url: `/api/v1/user/update`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: updateUserRequest, signal
    },
      options);
    }
  


export const getUpdateUserMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,{data: UpdateUserRequest}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,{data: UpdateUserRequest}, TContext> => {

const mutationKey = ['updateUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUser>>, {data: UpdateUserRequest}> = (props) => {
          const {data} = props ?? {};

          return  updateUser(data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserMutationResult = NonNullable<Awaited<ReturnType<typeof updateUser>>>
    export type UpdateUserMutationBody = UpdateUserRequest
    export type UpdateUserMutationError = ErrorType<unknown>

    /**
 * @summary Update the verified User's information
 */
export const useUpdateUser = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,{data: UpdateUserRequest}, TContext>, request?: SecondParameter<typeof customAxios>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateUser>>,
        TError,
        {data: UpdateUserRequest},
        TContext
      > => {
      return useMutation(getUpdateUserMutationOptions(options));
    }
    /**
 * @summary Records the marketing disclosure accepted by the authenticated patient after phone verification.
 */
export const captureMarketingConsent = (
    capturePatientMarketingConsentRequest: CapturePatientMarketingConsentRequest,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/user/marketing-consent`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: capturePatientMarketingConsentRequest, signal
    },
      options);
    }
  


export const getCaptureMarketingConsentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof captureMarketingConsent>>, TError,{data: CapturePatientMarketingConsentRequest}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof captureMarketingConsent>>, TError,{data: CapturePatientMarketingConsentRequest}, TContext> => {

const mutationKey = ['captureMarketingConsent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof captureMarketingConsent>>, {data: CapturePatientMarketingConsentRequest}> = (props) => {
          const {data} = props ?? {};

          return  captureMarketingConsent(data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type CaptureMarketingConsentMutationResult = NonNullable<Awaited<ReturnType<typeof captureMarketingConsent>>>
    export type CaptureMarketingConsentMutationBody = CapturePatientMarketingConsentRequest
    export type CaptureMarketingConsentMutationError = ErrorType<unknown>

    /**
 * @summary Records the marketing disclosure accepted by the authenticated patient after phone verification.
 */
export const useCaptureMarketingConsent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof captureMarketingConsent>>, TError,{data: CapturePatientMarketingConsentRequest}, TContext>, request?: SecondParameter<typeof customAxios>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof captureMarketingConsent>>,
        TError,
        {data: CapturePatientMarketingConsentRequest},
        TContext
      > => {
      return useMutation(getCaptureMarketingConsentMutationOptions(options));
    }
    /**
 * @summary Get a list of the user's previously redeemed rewards.
 */
export const getUserRewardHistory = (
    params?: GetUserRewardHistoryParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<GetUserRewardHistoryResultPagedResults>(
      {url: `/api/v1/user/reward-history`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetUserRewardHistoryQueryKey = (params?: GetUserRewardHistoryParams,) => {
    return [
    `/api/v1/user/reward-history`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetUserRewardHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getUserRewardHistory>>, TError = ErrorType<unknown>>(params?: GetUserRewardHistoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserRewardHistory>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserRewardHistoryQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserRewardHistory>>> = ({ signal }) => getUserRewardHistory(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserRewardHistory>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserRewardHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getUserRewardHistory>>>
export type GetUserRewardHistoryQueryError = ErrorType<unknown>


/**
 * @summary Get a list of the user's previously redeemed rewards.
 */

export function useGetUserRewardHistory<TData = Awaited<ReturnType<typeof getUserRewardHistory>>, TError = ErrorType<unknown>>(
 params?: GetUserRewardHistoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserRewardHistory>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUserRewardHistoryQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Get a list of the User's previous visits, i.e. their previous visits to one or more platforms.
 */
export const userGetVisitHistoryCheckIns = (
    params?: UserGetVisitHistoryCheckInsParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<GetVisitHistoryResultPagedResults>(
      {url: `/api/v1/user/check-ins`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getUserGetVisitHistoryCheckInsQueryKey = (params?: UserGetVisitHistoryCheckInsParams,) => {
    return [
    `/api/v1/user/check-ins`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getUserGetVisitHistoryCheckInsQueryOptions = <TData = Awaited<ReturnType<typeof userGetVisitHistoryCheckIns>>, TError = ErrorType<unknown>>(params?: UserGetVisitHistoryCheckInsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof userGetVisitHistoryCheckIns>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserGetVisitHistoryCheckInsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userGetVisitHistoryCheckIns>>> = ({ signal }) => userGetVisitHistoryCheckIns(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userGetVisitHistoryCheckIns>>, TError, TData> & { queryKey: QueryKey }
}

export type UserGetVisitHistoryCheckInsQueryResult = NonNullable<Awaited<ReturnType<typeof userGetVisitHistoryCheckIns>>>
export type UserGetVisitHistoryCheckInsQueryError = ErrorType<unknown>


/**
 * @summary Get a list of the User's previous visits, i.e. their previous visits to one or more platforms.
 */

export function useUserGetVisitHistoryCheckIns<TData = Awaited<ReturnType<typeof userGetVisitHistoryCheckIns>>, TError = ErrorType<unknown>>(
 params?: UserGetVisitHistoryCheckInsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof userGetVisitHistoryCheckIns>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getUserGetVisitHistoryCheckInsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Get a list of the User's previous visits, i.e. their previous visits to one or more platforms.
 */
export const userGetVisitHistoryVisits = (
    params?: UserGetVisitHistoryVisitsParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<GetVisitHistoryResultPagedResults>(
      {url: `/api/v1/user/visits`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getUserGetVisitHistoryVisitsQueryKey = (params?: UserGetVisitHistoryVisitsParams,) => {
    return [
    `/api/v1/user/visits`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getUserGetVisitHistoryVisitsQueryOptions = <TData = Awaited<ReturnType<typeof userGetVisitHistoryVisits>>, TError = ErrorType<unknown>>(params?: UserGetVisitHistoryVisitsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof userGetVisitHistoryVisits>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserGetVisitHistoryVisitsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userGetVisitHistoryVisits>>> = ({ signal }) => userGetVisitHistoryVisits(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userGetVisitHistoryVisits>>, TError, TData> & { queryKey: QueryKey }
}

export type UserGetVisitHistoryVisitsQueryResult = NonNullable<Awaited<ReturnType<typeof userGetVisitHistoryVisits>>>
export type UserGetVisitHistoryVisitsQueryError = ErrorType<unknown>


/**
 * @summary Get a list of the User's previous visits, i.e. their previous visits to one or more platforms.
 */

export function useUserGetVisitHistoryVisits<TData = Awaited<ReturnType<typeof userGetVisitHistoryVisits>>, TError = ErrorType<unknown>>(
 params?: UserGetVisitHistoryVisitsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof userGetVisitHistoryVisits>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getUserGetVisitHistoryVisitsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Get a paginated list of the User's Order History
 */
export const getOrderHistory = (
    params?: GetOrderHistoryParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<OrderHistoryLineItemModelPagedResults>(
      {url: `/api/v1/user/orders`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetOrderHistoryQueryKey = (params?: GetOrderHistoryParams,) => {
    return [
    `/api/v1/user/orders`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetOrderHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getOrderHistory>>, TError = ErrorType<void>>(params?: GetOrderHistoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrderHistory>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrderHistoryQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrderHistory>>> = ({ signal }) => getOrderHistory(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrderHistory>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOrderHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getOrderHistory>>>
export type GetOrderHistoryQueryError = ErrorType<void>


/**
 * @summary Get a paginated list of the User's Order History
 */

export function useGetOrderHistory<TData = Awaited<ReturnType<typeof getOrderHistory>>, TError = ErrorType<void>>(
 params?: GetOrderHistoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrderHistory>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOrderHistoryQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Get details on a specific User's Order
 */
export const getOrderHistoryDetails = (
    shopDisplayOrderId: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<CartModel>(
      {url: `/api/v1/user/orders/${shopDisplayOrderId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetOrderHistoryDetailsQueryKey = (shopDisplayOrderId: string,) => {
    return [
    `/api/v1/user/orders/${shopDisplayOrderId}`
    ] as const;
    }

    
export const getGetOrderHistoryDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getOrderHistoryDetails>>, TError = ErrorType<void>>(shopDisplayOrderId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrderHistoryDetails>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrderHistoryDetailsQueryKey(shopDisplayOrderId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrderHistoryDetails>>> = ({ signal }) => getOrderHistoryDetails(shopDisplayOrderId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(shopDisplayOrderId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrderHistoryDetails>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOrderHistoryDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getOrderHistoryDetails>>>
export type GetOrderHistoryDetailsQueryError = ErrorType<void>


/**
 * @summary Get details on a specific User's Order
 */

export function useGetOrderHistoryDetails<TData = Awaited<ReturnType<typeof getOrderHistoryDetails>>, TError = ErrorType<void>>(
 shopDisplayOrderId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrderHistoryDetails>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOrderHistoryDetailsQueryOptions(shopDisplayOrderId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Returns the current user's external transaction history, enriched with the adjusting admin's name where applicable.
 */
export const getExternalTransactions = (
    
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<ExternalTransactionDetails[]>(
      {url: `/api/v1/user/external-transactions`, method: 'GET', signal
    },
      options);
    }
  



export const getGetExternalTransactionsQueryKey = () => {
    return [
    `/api/v1/user/external-transactions`
    ] as const;
    }

    
export const getGetExternalTransactionsQueryOptions = <TData = Awaited<ReturnType<typeof getExternalTransactions>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getExternalTransactions>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetExternalTransactionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExternalTransactions>>> = ({ signal }) => getExternalTransactions(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getExternalTransactions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetExternalTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof getExternalTransactions>>>
export type GetExternalTransactionsQueryError = ErrorType<unknown>


/**
 * @summary Returns the current user's external transaction history, enriched with the adjusting admin's name where applicable.
 */

export function useGetExternalTransactions<TData = Awaited<ReturnType<typeof getExternalTransactions>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getExternalTransactions>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetExternalTransactionsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Check if the user can check-in
 */
export const checkIfUserCanCheckIn = (
    
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<boolean>(
      {url: `/api/v1/user/check-in`, method: 'GET', signal
    },
      options);
    }
  



export const getCheckIfUserCanCheckInQueryKey = () => {
    return [
    `/api/v1/user/check-in`
    ] as const;
    }

    
export const getCheckIfUserCanCheckInQueryOptions = <TData = Awaited<ReturnType<typeof checkIfUserCanCheckIn>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof checkIfUserCanCheckIn>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCheckIfUserCanCheckInQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof checkIfUserCanCheckIn>>> = ({ signal }) => checkIfUserCanCheckIn(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof checkIfUserCanCheckIn>>, TError, TData> & { queryKey: QueryKey }
}

export type CheckIfUserCanCheckInQueryResult = NonNullable<Awaited<ReturnType<typeof checkIfUserCanCheckIn>>>
export type CheckIfUserCanCheckInQueryError = ErrorType<unknown>


/**
 * @summary Check if the user can check-in
 */

export function useCheckIfUserCanCheckIn<TData = Awaited<ReturnType<typeof checkIfUserCanCheckIn>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof checkIfUserCanCheckIn>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getCheckIfUserCanCheckInQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Get user preferences (journey experience, skin tone, concerns, etc.)
 */
export const getPreferences = (
    
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<UserPreferences>(
      {url: `/api/v1/user/preferences`, method: 'GET', signal
    },
      options);
    }
  



export const getGetPreferencesQueryKey = () => {
    return [
    `/api/v1/user/preferences`
    ] as const;
    }

    
export const getGetPreferencesQueryOptions = <TData = Awaited<ReturnType<typeof getPreferences>>, TError = ErrorType<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPreferences>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPreferencesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPreferences>>> = ({ signal }) => getPreferences(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPreferences>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPreferencesQueryResult = NonNullable<Awaited<ReturnType<typeof getPreferences>>>
export type GetPreferencesQueryError = ErrorType<void>


/**
 * @summary Get user preferences (journey experience, skin tone, concerns, etc.)
 */

export function useGetPreferences<TData = Awaited<ReturnType<typeof getPreferences>>, TError = ErrorType<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPreferences>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPreferencesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}




/**
 * @summary Save user preferences (journey experience, skin tone, concerns, etc.)
 */
export const savePreferences = (
    savePreferencesRequest: SavePreferencesRequest,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<void>(
      {url: `/api/v1/user/preferences`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: savePreferencesRequest, signal
    },
      options);
    }
  


export const getSavePreferencesMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof savePreferences>>, TError,{data: SavePreferencesRequest}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof savePreferences>>, TError,{data: SavePreferencesRequest}, TContext> => {

const mutationKey = ['savePreferences'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof savePreferences>>, {data: SavePreferencesRequest}> = (props) => {
          const {data} = props ?? {};

          return  savePreferences(data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type SavePreferencesMutationResult = NonNullable<Awaited<ReturnType<typeof savePreferences>>>
    export type SavePreferencesMutationBody = SavePreferencesRequest
    export type SavePreferencesMutationError = ErrorType<void>

    /**
 * @summary Save user preferences (journey experience, skin tone, concerns, etc.)
 */
export const useSavePreferences = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof savePreferences>>, TError,{data: SavePreferencesRequest}, TContext>, request?: SecondParameter<typeof customAxios>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof savePreferences>>,
        TError,
        {data: SavePreferencesRequest},
        TContext
      > => {
      return useMutation(getSavePreferencesMutationOptions(options));
    }
    /**
 * @summary Change the phone number of the current user. If another user already uses the number, the current
platform user is linked to that user instead.
 */
export const changePhoneNumber = (
    changePhoneNumberForPlatformUserRequest: ChangePhoneNumberForPlatformUserRequest,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {
      
      
      return customAxios<DisplayChangePhoneNumberForPlatformUserResponse>(
      {url: `/api/v1/user/phone-number`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: changePhoneNumberForPlatformUserRequest, signal
    },
      options);
    }
  


export const getChangePhoneNumberMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changePhoneNumber>>, TError,{data: ChangePhoneNumberForPlatformUserRequest}, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof changePhoneNumber>>, TError,{data: ChangePhoneNumberForPlatformUserRequest}, TContext> => {

const mutationKey = ['changePhoneNumber'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changePhoneNumber>>, {data: ChangePhoneNumberForPlatformUserRequest}> = (props) => {
          const {data} = props ?? {};

          return  changePhoneNumber(data,requestOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type ChangePhoneNumberMutationResult = NonNullable<Awaited<ReturnType<typeof changePhoneNumber>>>
    export type ChangePhoneNumberMutationBody = ChangePhoneNumberForPlatformUserRequest
    export type ChangePhoneNumberMutationError = ErrorType<void>

    /**
 * @summary Change the phone number of the current user. If another user already uses the number, the current
platform user is linked to that user instead.
 */
export const useChangePhoneNumber = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changePhoneNumber>>, TError,{data: ChangePhoneNumberForPlatformUserRequest}, TContext>, request?: SecondParameter<typeof customAxios>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof changePhoneNumber>>,
        TError,
        {data: ChangePhoneNumberForPlatformUserRequest},
        TContext
      > => {
      return useMutation(getChangePhoneNumberMutationOptions(options));
    }
    